import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {RegionModel} from '../../../../models/RegionModel';
import {FilterAbstractModel} from '../../../../models/FilterAbstractModel';

@Component({
  selector: 'app-region-filter',
  templateUrl: './region-filter.component.html',
  styleUrls: ['./region-filter.component.scss']
})
export class RegionFilterComponent extends FilterAbstractModel implements OnInit, OnChanges, OnDestroy {

  listRegionFilter: any[];

  @Input() regionData: any;
  @Input() regionSelected: RegionModel;

  constructor() {
    super();
  }

  ngOnInit() {
  }

  ngOnChanges (changes: SimpleChanges) {
    if ('regionData' in changes) {
      this.listRegionFilter = this.regionData ? this.regionData : [];
      this.optionSelected = null;
    }
    if (this.regionSelected) {
      this.optionSelected = this.regionSelected;
    }
  }

  ngOnDestroy(): void {
  }

}
